import React from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const EndemismSection = ({ stats }) => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="mt-20 rounded-[40px] overflow-hidden shadow-2xl shadow-red-900/20"
        >
            <div className="bg-red-700 text-white p-10 md:p-16">
                {/* Summary Header */}
                <div className="max-w-3xl mb-16">
                    <h3 className="text-4xl md:text-6xl font-bold mb-6 tracking-tight leading-tight">
                        High Degree of <br />
                        <span className="text-red-200">Endemism.</span>
                    </h3>
                    <p className="text-red-100 text-lg md:text-xl font-medium max-w-xl">
                        Sri Lanka's isolation and varied climate have resulted in a significant percentage of species found nowhere else on Earth.
                    </p>
                </div>

                {/* Endemism Grid */}
                <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-px bg-red-500/30 border border-red-500/30 rounded-3xl overflow-hidden">
                    {stats.map((item, i) => (
                        <div key={i} className="bg-red-600 p-8 flex flex-col items-center group hover:bg-red-500/50 transition-colors duration-300">
                            <span className="text-[10px] font-black uppercase tracking-widest mb-6 opacity-70 group-hover:opacity-100 transition-opacity">
                                {item.label}
                            </span>
                            <div className="text-4xl md:text-5xl font-black mb-6 tracking-tighter">
                                {item.pct}
                            </div>
                            <div className="w-12 h-12 rounded-2xl bg-white/10 flex items-center justify-center text-white/90 group-hover:scale-110 group-hover:bg-white/20 transition-all duration-300">
                                <FontAwesomeIcon icon={item.icon} size="lg" />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </motion.div>
    );
};

export default EndemismSection;
